<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            inline-prompt
            active-text="正常"
            active-color="#1e90ff"
            inactive-text="停用"
            inactive-color="#f00"
            :active-value="1"
            :inactive-value="0"
            style="--el-switch-off-color: #f00"
          />
        </el-form-item>
        <el-form-item
          label="企业名称"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请填写企业名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="所属行业"
          prop="d_industry_id"
          :rules="[
            {
              required: true,
              message: '请选择所属行业',
              trigger: 'blur',
            },
          ]"
        >
          <el-tree-select
            v-model="state.model.d_industry_id"
            :data="state.industryData"
            node-key="id"
            clearable
            accordion
            :props="{ label: 'name' }"
            :render-after-expand="false"
            :highlight-current="true"
            :default-expand-all="true"
            :check-strictly="true"
            placeholder="--所属行业--"
            @clear="delete state.model.d_industry_id"
            filterable
          >
            <template #default="{ data }">
              <div style="display: flex; align-items: center">
                {{ data.name }}
              </div>
            </template>
            <template #footer>
              <el-button size="small" @click="onLoadIndustry()">刷新</el-button>
            </template>
          </el-tree-select>
        </el-form-item>
        <el-form-item
          label="统一社会信用代码"
          prop="unified_social_credit_identifier"
          :rules="[
            {
              required: true,
              message: '请填写统一社会信用代码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="state.model.unified_social_credit_identifier"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="所属地区"
          prop="area"
          :rules="[
            {
              required: true,
              message: '请填写地区',
              trigger: 'blur',
            },
          ]"
        >
          <el-cascader
            v-model="state.model.area"
            :options="state.areaData"
            :props="{ label: 'name', value: 'name' }"
            placeholder="--所属地区--"
            style="width: 100%"
            clearable
            filterable
          />
        </el-form-item>
        <el-form-item
          label="所在地址"
          prop="address"
          :rules="[
            {
              required: true,
              message: '请填写所在地址',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.address"></el-input
        ></el-form-item>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  contractunit_add,
  contractunit_detail,
  contractunit_edit,
} from "@/http/contractunit";
import { data_industry_tree, data_areacode_tree } from "@/http/data";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        sex: 0,
        property: 0,
      },
    });
    onMounted(() => {
      onLoadIndustry();
      onLoadAreaCode();

      if (props.id) {
        contractunit_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;

            if (state.model.district) {
              state.model.area = [
                state.model.province,
                state.model.city,
                state.model.district,
              ];
            }
          }
        });
      }
    });

    //获取行业树
    const onLoadIndustry = () => {
      data_industry_tree().then((res) => {
        if (res.status == 200) state.industryData = res.data.data;
      });
    };

    const onLoadAreaCode = () => {
      data_areacode_tree().then((res) => {
        if (res.status == 200) state.areaData = res.data.data?.list;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.area?.length == 3) {
            state.model.province = state.model.area[0];
            state.model.city = state.model.area[1];
            state.model.district = state.model.area[2];
          }

          if (props.id) {
            contractunit_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            contractunit_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onLoadIndustry,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
